import {
  getUserModuleGrantsStore,
  mutateUserModuleGrants,
} from "../data/user-module-grants.store";
import type { UserModuleGrant } from "../types";

const now = () => new Date().toISOString();

export const userModuleAccessService = {
  listGrantsForUser(tenantId: string, userId: string): UserModuleGrant[] {
    return getUserModuleGrantsStore().filter(
      (g) => g.tenantId === tenantId && g.userId === userId
    );
  },

  listGrantedModuleIds(tenantId: string, userId: string): string[] {
    return this.listGrantsForUser(tenantId, userId)
      .filter((g) => g.granted)
      .map((g) => g.moduleId);
  },

  listGrantsForTenant(tenantId: string): UserModuleGrant[] {
    return getUserModuleGrantsStore().filter((g) => g.tenantId === tenantId);
  },

  setGrant(
    tenantId: string,
    userId: string,
    moduleId: string,
    granted: boolean
  ): UserModuleGrant {
    const timestamp = now();
    let result: UserModuleGrant | null = null;

    mutateUserModuleGrants((current) => {
      const idx = current.findIndex(
        (g) =>
          g.tenantId === tenantId &&
          g.userId === userId &&
          g.moduleId === moduleId
      );
      if (idx >= 0) {
        const updated = { ...current[idx], granted, updatedAt: timestamp };
        result = updated;
        const next = [...current];
        next[idx] = updated;
        return next;
      }
      const created: UserModuleGrant = {
        tenantId,
        userId,
        moduleId,
        granted,
        updatedAt: timestamp,
      };
      result = created;
      return [...current, created];
    });

    return result!;
  },

  setGrantsForUser(
    tenantId: string,
    userId: string,
    moduleIds: string[]
  ): void {
    const allowed = new Set(moduleIds);
    mutateUserModuleGrants((current) => {
      const others = current.filter(
        (g) => !(g.tenantId === tenantId && g.userId === userId)
      );
      const timestamp = now();
      const next = [...others];
      for (const moduleId of allowed) {
        next.push({
          tenantId,
          userId,
          moduleId,
          granted: true,
          updatedAt: timestamp,
        });
      }
      return next;
    });
  },

  applyPreset(
    tenantId: string,
    userId: string,
    moduleIds: string[]
  ): void {
    this.setGrantsForUser(tenantId, userId, moduleIds);
  },
};
